import styles from './styles.module.scss'

function Time({ text }) {
  return <span className={styles.message_time}>{text}</span>
}

export default Time
